import { computed } from 'vue';
import { useUserStore } from '@/store/user';

/**
 * `app_customization.mandatory_incident_dates` decides how the incident dates
 * behave:
 *
 * - `false` - works like before: date and time are prefilled with "now" and can
 *             be changed, but the report goes through either way.
 * - `true`  - nothing is prefilled and the user has to pick both date and time
 *             before the report can be submitted.
 *
 * Read through this composable (rather than the user store directly) so the
 * date inputs and the validation in the incident store can never disagree.
 * Before the user is loaded the dates behave as they always have.
 */
export function useMandatoryIncidentDates() {
  const userStore = useUserStore();

  const datesMandatory = computed(
    () => !!userStore.currentUser?.app_customization?.mandatory_incident_dates
  );

  return { datesMandatory };
}

export default useMandatoryIncidentDates;
